// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__ZH9Ge","modalFooterButton":"ModalNotes_modalFooterButton__1mjcO"};